module.exports = __webpack_public_path__ + "img/inst-18.16f6b1c7.png";